import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isLoggedIn, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // 只有在加载完成且未登录时才重定向
    if (!isLoading && !isLoggedIn) {
      navigate("/login", { state: { from: location.pathname } });
    }
  }, [isLoading, isLoggedIn, navigate, location]);

  // 加载中或未登录时显示加载状态
  if (isLoading || !isLoggedIn) {
    return (
      <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center">
        <div className="flex items-center gap-2 text-gray-500">
          <i className="ri-loader-4-line animate-spin text-xl" />
          <span>请稍候...</span>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}